import { PageWrapper } from './page-wrapper';
import ProtectedRoute from 'features/auth/components/protected-route';
import { Page } from 'features/shared/model';
import { PageLink, PageTitle } from 'layouts/core/page-data';
import { Outlet, Route, Routes } from 'react-router';
import { IframeDialogProvider } from 'widgets/iframe-dialog';

const breadcrumbs: Array<PageLink> = [
  {
    title: 'Admin Panel',
    path: '/warranty-logs',
    isSeparator: false,
    isActive: false
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false
  }
];

export const WarrantyLogsPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          index
          element={
            <ProtectedRoute page={Page.WarrantyLog}>
              <PageTitle breadcrumbs={breadcrumbs}>Warranty Log</PageTitle>
              <IframeDialogProvider>
                <PageWrapper />
              </IframeDialogProvider>
            </ProtectedRoute>
          }
        />
      </Route>
    </Routes>
  );
};
